import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { OfferListingStatus } from '@steelbuy/ts-shared';

export interface SearchResultsContextValue {
    filter: OfferListingStatus[];
    setFilter: (filter: OfferListingStatus[]) => void;
}

const defaultValue: SearchResultsContextValue = {
    filter: [],
    setFilter: () => null,
};

const MyOffersContext = createContext(defaultValue);

export const MyOffersContextProvider = ({ children }: { children: ReactNode }) => {
    const [filter, setFilter] = useState<OfferListingStatus[]>([]);
    const value = useMemo(
        () => ({
            filter,
            setFilter,
        }),
        [filter, setFilter]
    );

    return <MyOffersContext.Provider value={value}>{children}</MyOffersContext.Provider>;
};

export const useMyOffersContext = () => useContext(MyOffersContext);
